import { useRef, useEffect } from "react";
import { Send, X } from "lucide-react";

export const ActionForm = ({ config, value, onChange, onCancel, onSubmit, sending, error }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.focus({ preventScroll: true });
  }, [config]);

  const emptyRequired = config.required && !value.trim();
  const submit = (e) => {
    e.preventDefault();
    if (emptyRequired) return;
    onSubmit();
  };

  return (
    <form onSubmit={submit} className="wd-fade-in mt-4 p-4 rounded-2xl" style={{ background: "#fff", border: "1px solid #E2E8F0" }} data-testid="action-form">
      <label htmlFor="action-message" className="block text-sm font-bold mb-1">{config.formTitle}</label>
      {config.help && <p className="text-xs mb-2" style={{ color: "#64748B" }}>{config.help}</p>}
      <textarea id="action-message" ref={ref} data-testid="action-message" rows={3} className="input-wd"
        value={value} onChange={(e) => onChange(e.target.value)} placeholder={config.placeholder}
        aria-required={config.required ? "true" : "false"}
        aria-invalid={error ? "true" : "false"} aria-describedby={error ? "action-error" : undefined} />
      {emptyRequired && !error && (
        <p className="text-xs mt-1" style={{ color: "#94A3B8" }}>Pflichtfeld – bitte ausfüllen.</p>
      )}
      {error && (
        <p id="action-error" role="alert" className="text-sm font-semibold mt-2" style={{ color: "#DC2626" }} data-testid="action-error">{error}</p>
      )}
      <div className="flex justify-end gap-3 mt-3">
        <button type="button" className="btn-secondary" onClick={onCancel} data-testid="action-cancel">
          <X size={16} /> Abbrechen
        </button>
        <button type="submit" className="btn-primary" data-testid="action-submit" disabled={sending || emptyRequired}>
          <Send size={16} /> {sending ? "Senden…" : "Senden"}
        </button>
      </div>
    </form>
  );
};
